"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var splitUrlPiece = function (splitter, url) {
    if (url === void 0) { url = ''; }
    if (url.indexOf(splitter) < 0) {
        url = "" + url + splitter;
    }
    var splitterIndex = url.indexOf(splitter);
    return {
        baseHref: url.substring(0, splitterIndex),
        queryString: url.substring(splitterIndex + 1),
    };
};
exports.default = splitUrlPiece;
